function mergeNotNull(a, b) {
  const objB = { ...b };
  Object.keys(objB).forEach((k) => {
    if (objB[k] === null) { delete objB[k]; }
  });
  return { ...a, ...objB };
}
export default mergeNotNull;
